import React, { FunctionComponent, useEffect, useState } from 'react';
import { FormGroup } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';

import { SimpleSelect, IItem } from '../../select';

type Callback = (value: any) => void;

interface IExecutionTimeframeProps {
  onChange: Callback;
  reset: boolean;
}

const OPTIONS: IItem[] = [
  {
    label: 'Last 24 hours',
    value: '1', // days
    icon: IconNames.CALENDAR,
  },
  {
    label: 'Last week',
    value: '7',
    icon: IconNames.CALENDAR,
  },
  {
    label: 'Last 2 weeks',
    value: '14',
    icon: IconNames.CALENDAR,
  },
  {
    label: 'Last 30 days',
    value: '30',
    icon: IconNames.CALENDAR,
  },
]; // relative date options

const ExecutionTimeframeContainer: FunctionComponent<IExecutionTimeframeProps> = ({
  onChange,
  reset,
}: IExecutionTimeframeProps) => {
  const [ selected, setSelected ] = useState<any>(null);

  useEffect(() => {
    if (reset) {
      setSelected(null);
    }
  }, [ reset ]);

  const onSelectChange = (item: IItem) => {
    setSelected(item);
    onChange(item);
  }

  return (
    <FormGroup label="Execution Timeframe" className="execution-filters__timeframe">
      <SimpleSelect
        disabled={false}
        selected={selected}
        onChange={onSelectChange}
        options={OPTIONS}
        popoverProps={{usePortal: true}}
        buttonProps={{minimal: false, fill: true}}
      />
    </FormGroup>
  )
}

export default ExecutionTimeframeContainer;
